import React, { useState, useEffect } from 'react'
import {Redirect} from 'react-router-dom'

import NavHeaderLayout from './NavHeaderLayout'
import Auth from '../services/Auth'
import './NavHeader.scss'
import RoleContext, { getRoleLabel } from '../signin/RoleContext'
import { Routes } from '../App'
import ActionRequestNotification from '../actionRequired/ActionRequestNotification'
import { default as NotificationService } from '../services/Notification'
import NotificationList, { Notification } from './../notification/NotificationList';

//import SessionExpiryModal from '../SessionExpiryModal';



const NavHeader = () => {
  const [loggedOut, setLoggedOut] = useState(false)
  const [notifications, setNotifications] = useState<Notification[] | undefined>(undefined)

  useEffect(() => {
    const fetchData = async () => {
      const response = await NotificationService.getDashboard();
      if (response.content?.value != null) {
        setNotifications(response.content.value);
      }
    };

    fetchData();
  }, []);

  const getWelcomeMessage = () => {
    let msg = ''
    const firstName = Auth.getFirstName()
    if (firstName) {
      msg = 'Welcome back, ' + firstName
    } else {
      msg = 'Hello!'
    }
    return msg
  }

  const getInitials = () => {
    let initials = ''
    const firstName = Auth.getFirstName()
    const lastName = Auth.getLastName()

    if (firstName) {
      initials += firstName.charAt(0)
    }
    if (lastName) {
      initials += lastName.charAt(0)
    }

    return initials
  }

  const signOut = () => {
    setLoggedOut(true)
  }

  if (loggedOut) {
    return <Redirect to={Routes.SignOut} />
  }

  return (
    <div>
      <ActionRequestNotification mode="PasswordExpiry" />
      <NotificationList notifications={notifications} />

      {/*<SessionExpiryModal /> */}
      <RoleContext.Consumer>
        {({role}) => {
          return (
            <NavHeaderLayout
              message={getWelcomeMessage()}
              initials={getInitials()}
              onSignout={signOut}
              userRole={getRoleLabel(role)}
            />
          )
        }}
      </RoleContext.Consumer>
    </div>
  )
}

export default NavHeader
